module.exports = __webpack_public_path__ + "img/logo.d1be6443.png";